var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "552BBFD9-1A63-4452-8F2C-A09758236029") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M22.8915556,20.2673333 L13.0386667,1.79511111 C12.4537778,0.696888889 10.8795556,0.696888889 10.2931111,1.79511111 L0.441777778,20.2673333 C-0.110444444,21.3033333 0.640888889,22.5555556 1.81533333,22.5555556 L21.5195556,22.5555556 C22.6924444,22.5555556 23.4437778,21.3033333 22.8915556,20.2673333 Z M11.6666667,19.4444444 C10.808,19.4444444 10.1111111,18.7475556 10.1111111,17.8888889 C10.1111111,17.0302222 10.808,16.3333333 11.6666667,16.3333333 C12.5253333,16.3333333 13.2222222,17.0302222 13.2222222,17.8888889 C13.2222222,18.7475556 12.5253333,19.4444444 11.6666667,19.4444444 Z M13.2222222,14.7777778 L10.1111111,14.7777778 L10.1111111,8.55555556 L13.2222222,8.55555556 L13.2222222,14.7777778 Z",
    id: "path-1-hazard"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GLOBAL---COMMUNICATIONS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communications---Dashboard---Basic",
    transform: "translate(-641.000000, -910.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Compliance-Notification-Center",
    transform: "translate(204.000000, 582.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Program-Card---LCR",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stat---Detect",
    transform: "translate(425.000000, 262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle-Icon---Translucent",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.333333, 12.333333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-hazard",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-hazard"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#111111",
    fillRule: "nonzero",
    xlinkHref: "#path-1-hazard"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-\\uD83C\\uDFA8Color",
    mask: "url(#mask-2-hazard)",
    fill: "#FFB000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.555556, -7.000000)",
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 37.3333333,
    height: 37.3333333
  }))))))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazard);
export default __webpack_public_path__ + "static/media/Hazard.93f30630.svg";
export { ForwardRef as ReactComponent };